<br>


<div [hidden]="showEndDiv">
{{basPath}}
  <table class="table table-hover table-bordered" style="width:40%;margin-left: 25px;font-size: 12px;
  font-weight: 300!important;" >
    <thead>
      <tr>
        <th scope="col" >Endpoint URL</th>
        <th scope="col" >Type</th>
       
      </tr>
    </thead>
    <tbody>
      <tr class="aetna-p" *ngFor="let pth of endpoints">
        <td style="font-size: 12px;
        font-weight: 300!important;">{{pth.endpointUrl}}</td>
        <td style="font-size: 12px;
        font-weight: 300!important;">{{pth.type}}</td>
        
      </tr>
      </tbody>
  </table>
  


</div>


<div id="swagger-ui">

</div>


 

